export const getFloat = (value) => {
    return parseFloat(value) || 0;
}
